// On-Demand Transaction Status Retrieval Translations
export const transactionStatusRetrievalTranslations = {
  en: {
    // Locally-authored UI strings
    retrieveTransactionStatus: "Retrieve Status",
    retrievingTransactionStatus: "Retrieving...",
    transactionApprovedRetrieval: "Transaction approved",
    transactionDeclinedRetrieval: "Transaction declined",
    statusRetrievalNetworkError: "Couldn't complete the request. Please try again.",

    // Backend message catalog - self-mapped, keyed by the exact backend `message` string.
    // t(response.message) looks these up directly; keep in sync with the backend contract.
    "Transaction status updated from terminal.": "Transaction status updated from terminal.",
    "Transaction status could not be retrieved from the terminal.": "Transaction status could not be retrieved from the terminal.",
    "Terminal's transaction does not match the requested reference number.": "Terminal's transaction does not match the requested reference number.",
    "Malformed terminal response.": "Malformed terminal response.",
    "Transaction status could not be retrieved from the terminal (timeout).": "Transaction status could not be retrieved from the terminal (timeout).",
    "Status retrieval is not supported for this terminal type.": "Status retrieval is not supported for this terminal type.",
    "Transaction not found.": "Transaction not found.",
    "Transaction is not eligible for status retrieval.": "Transaction is not eligible for status retrieval.",
    "The terminal is currently busy. Please try again shortly.": "The terminal is currently busy. Please try again shortly.",
    "No active cashier session on this terminal.": "No active cashier session on this terminal.",
    "Server error": "Server error",
    "Duplicate reference number - status cannot be verified.": "Duplicate reference number - status cannot be verified.",
  },
  ar: {
    // Locally-authored UI strings
    retrieveTransactionStatus: "استرجاع الحالة",
    retrievingTransactionStatus: "جارٍ الاسترجاع...",
    transactionApprovedRetrieval: "تمت الموافقة على المعاملة",
    transactionDeclinedRetrieval: "تم رفض المعاملة",
    statusRetrievalNetworkError: "تعذر إتمام الطلب. يرجى المحاولة مرة أخرى.",

    // Backend message catalog - Arabic translations, keyed by the exact English backend `message` string.
    "Transaction status updated from terminal.": "تم تحديث حالة المعاملة من الجهاز.",
    "Transaction status could not be retrieved from the terminal.": "تعذر استرجاع حالة المعاملة من الجهاز.",
    "Terminal's transaction does not match the requested reference number.": "معاملة الجهاز لا تطابق الرقم المرجعي المطلوب.",
    "Malformed terminal response.": "استجابة غير صالحة من الجهاز.",
    "Transaction status could not be retrieved from the terminal (timeout).": "تعذر استرجاع حالة المعاملة من الجهاز (انتهت المهلة).",
    "Status retrieval is not supported for this terminal type.": "استرجاع الحالة غير مدعوم لهذا النوع من الأجهزة.",
    "Transaction not found.": "المعاملة غير موجودة.",
    "Transaction is not eligible for status retrieval.": "المعاملة غير مؤهلة لاسترجاع الحالة.",
    "The terminal is currently busy. Please try again shortly.": "الجهاز مشغول حالياً. يرجى المحاولة مرة أخرى بعد قليل.",
    "No active cashier session on this terminal.": "لا توجد جلسة كاشير نشطة على هذا الجهاز.",
    "Server error": "خطأ في الخادم",
    "Duplicate reference number - status cannot be verified.": "رقم مرجعي مكرر - لا يمكن التحقق من الحالة.",
  }
};

// Helper function to add these translations to i18n
export const addTransactionStatusRetrievalTranslations = (i18n: any) => {
  Object.keys(transactionStatusRetrievalTranslations).forEach((lang) => {
    i18n.addResources(lang, 'translation', transactionStatusRetrievalTranslations[lang as keyof typeof transactionStatusRetrievalTranslations]);
  });
};
